import { ToBlob } from "@pdfking/tfunc"

export default (bytes: Uint8Array, mimetype: string): string =>
  URL.createObjectURL(ToBlob(bytes, mimetype))
